let config = {
  api_url: process.env.REACT_APP_API_URL,
  jwt_store_key: "beauty_admin_jwt_secret_storage",
};

export default config;
